export default __webpack_public_path__ + "static/media/icon-close.3f21c96c.svg";